import { Fragment } from 'react';
import { Outlet } from 'react-router-dom';

// import ContactForm from '../../components/contact-form/contact-form.component';
import Logo from '../../assets/logo-responsive-invert.png';

import { FooterContainer, LogoFooterContainer, LogoFooter, FooterDataList } from './footer.styles.jsx';

const Footer = () => {
  return (
    <Fragment>
      <Outlet />
      <FooterContainer>
        <LogoFooterContainer>
          <LogoFooter src={Logo} alt='logo' />
        </LogoFooterContainer>
        <div>
          <FooterDataList>
            <li>Maria Teresa Cortada</li>
            <li>Martillera, Corredora Pública y Corredora Inmobiliaria</li>
            <li>Matricula Nro. 347/COCICH</li>
          </FooterDataList>
        </div>
        {/* <ContactForm /> */}
      </FooterContainer>
    </Fragment>
  )
}

export default Footer;